module.exports = __webpack_public_path__ + "img/errorMessageFirefox.e40cd506.jpg";